var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('img',{attrs:{"src":"/web/img/visa-mobile/trx-success.svg","alt":"Sukces"}})])
}]

export { render, staticRenderFns }